import { queryOptions } from '@tanstack/react-query';
import { siteconfigAPIClient } from '../siteconfigAPIClient';
import { SITECONFIG_QUERY_KEYS } from './keys';
import type { GetShippingPolicyRequest } from './types';

export const SITECONFIG_QUERIES = {
  getShippingPolicies: () =>
    queryOptions({
      queryKey: SITECONFIG_QUERY_KEYS.getShippingPolicies(),
      queryFn: () => siteconfigAPIClient.getShippingPolicies(),
    }),
  getShippingPolicy: (params: GetShippingPolicyRequest) =>
    queryOptions({
      queryKey: SITECONFIG_QUERY_KEYS.getShippingPolicy(params),
      queryFn: () => siteconfigAPIClient.getShippingPolicy(params),
    }),
};
